import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel'
import { Box, Tab } from '@mui/material';
import { useState } from 'react';
import TeamPermission from './TeamPermission';
import EmployeePermissionApproval from './EmployeePermissionApproval';

const PermissionLandingPage = () => {
    const [value, setValue] = useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <TabContext value={value}>
                <Box>
                    <TabList 
                        sx={{
                            minHeight: "40px", mb: 1, ".MuiTab-root": { minHeight: "20px" },
                            '& .MuiTabs-indicator': {
                                width: '100%',
                                display: 'flex',
                                justifyContent: "center !important",
                            },
                            }} 
                            onChange={handleChange} 
                            aria-label="lab API tabs example"
                            variant="scrollable"
                            orientation="horizontal"
                            allowScrollButtonsMobile={true}
                        >
                        <Tab label="All Employee" value="1" />
                        <Tab label="Action Required" value="2" />
                        <Tab label="Action Completed" value="3" />
                    </TabList>
                </Box>                            
                <TabPanel value="1" sx={{ padding: "0px" }}>
                    <TeamPermission />
                </TabPanel>
                <TabPanel value="2" sx={{ padding: "0px" }}>
                    <EmployeePermissionApproval value={"2"} />
                </TabPanel>
                <TabPanel value="3" sx={{ padding: "0px" }}>
                    <EmployeePermissionApproval value={"3"} />
                </TabPanel>
            </TabContext>
        </Box>
    )
}

export default PermissionLandingPage;